<div
  class="container-fluid main-section-home-container p-0 position-relative d-flex justify-content-center"
>
  <div
    class="mt-5 w-75 h-75 d-flex flex-column align-items-center p-2 p-md-0 justify-content-center main-section-home-content text-white position-relative pt-5 gap-5"
  >
    <img
      src="../../../assets/images/logo.png"
      alt=""
      class="home-img"
      data-aos="fade-up"
      data-aos-duration="2000"
      data-aos-offset="200"
      data-aos-once="true"
    />
    <p
      class="fs-1 text-wrap m-0 lh-sm text-center home-text"
      data-aos="fade-up"
      data-aos-duration="2000"
      data-aos-delay="1000"
      data-aos-offset="200"
      data-aos-once="true"
      >
      {{
        "We specialize in programming applications with the latest technologies"
          | translate
      }}
    </p>
  </div>
</div>

<!-- <div class="container-fluid main-section-home-container p-0 position-relative">
  <div class="overlay"></div>
  <div
    class="w-100 h-75 d-flex flex-column align-items-md-center align-items-end p-2 p-md-0 justify-content-center  main-section-home-content text-white position-relative pt-5"
  >
    <h2 class="font-weight-bolder fs-64px mb-5 mt-3">تجربة العدسة</h2>
    <p class="m-0">
      تُعتبر العدسات طريقة مؤثّرة تبقى في البال للتواصل مع المستهلكين باستخدام
      الواقع المُعزّز.
    </p>
    <p
      class="px-4 py-3 mt-4 rounded-pill curser-pointer text-black font-weight-bold fs-6 bg-custom-yellow"
    >
      إنشاء إعلان
    </p>
  </div>
  <svg
    preserveAspectRatio="none"
    class="position-absolute bottom-0 main-section-home-svg"
    viewBox="0 0 1595 197"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
  >
    <path
      d="M1310.47 110.038C1363.08 107.561 1454.12 104.515 1533.36 124.425C1553.59 129.286 1577.82 137.968 1594.82 150.317L1594.82 222.424L-5.22662 222.424L-5.22659 90.1601C35.4514 71.3813 81.0696 54.2379 132.832 39.687C339.948 -18.5357 474.389 11.5859 582.345 36.5655C628.282 49.0675 676.449 56.5073 725.88 58.7358C810.326 57.5247 895.863 45.0391 979.708 21.685C1044.66 5.22551 1095.79 -6.79795 1140.77 5.8709C1157.26 11.0807 1171.96 19.3644 1183.98 30.2357C1196.01 41.1069 1205.12 54.3464 1210.79 69.1769C1215.12 82.6739 1223.03 94.6486 1233.93 104.168C1244.79 109.425 1257.35 111.935 1270.45 111.468C1282.56 111.245 1296.04 110.638 1310.47 110.038Z"
      fill="var(--globalvar-basecolor-white-bg)"
    ></path>
  </svg>
</div> -->
